import { Button, Checkbox } from '@carbon/react';
import { Undo } from '@carbon/icons-react';
import style from './tc-unit-shape-edit-controls.module.scss';

interface TcUnitShapeEditControlsProps {
  canUndo: boolean;
  onUndo: () => void;
  /** Snap dragged vertices to the unit's and its surveys' own vertices. */
  snap: boolean;
  onSnapChange: (snap: boolean) => void;
}

/**
 * Controls that accompany unit boundary editing, floating over the map.
 *
 * In the Unit Builder mock these live in the surrounding panels (Snap to
 * landgrid sits with the map toggles, Undo with the Survey Areas panel). Until
 * those panels exist this strip carries them, so the editor is reachable and
 * testable on the workspace map.
 *
 * @param {TcUnitShapeEditControlsProps} props - Undo and snap state.
 * @return {JSX.Element} The floating control strip.
 */
const TcUnitShapeEditControls = ({
  canUndo,
  onUndo,
  snap,
  onSnapChange,
}: TcUnitShapeEditControlsProps) => (
  <div className={style.controls}>
    <span className={style.hint}>
      Drag a vertex to reshape · click a midpoint to add · right-click to delete
    </span>
    <Checkbox
      id="tc-unit-shape-snap"
      labelText="Snap to landgrid"
      checked={snap}
      onChange={(_event, { checked }: { checked: boolean }) =>
        onSnapChange(checked)
      }
    />
    <Button
      kind="ghost"
      size="sm"
      renderIcon={Undo}
      disabled={!canUndo}
      onClick={onUndo}
    >
      Undo
    </Button>
  </div>
);

export { TcUnitShapeEditControls };
